import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookSquare, faPinterestSquare, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons'
import React from 'react';
import { Button, Container, Col, Form, FloatingLabel, Row } from 'react-bootstrap';


const footer = () => {


    return (<>
        <Container fluid className="top-footer">
            <div className="footer-container">
                <Row>
                    <Col className="footer-column" xs={12} md={4}>
                        <h3 className="mb-3 bolder">Connect with Us</h3>
                        <div className="social-links">
                            <div><a href="http://www.facebook.com/ahrq.gov"><FontAwesomeIcon size="3x" icon={faFacebookSquare} /></a></div>
                            <div><a href="https://twitter.com/ahrqnews"><FontAwesomeIcon size="3x" icon={faPinterestSquare} /></a></div>
                            <div><a href="http://www.youtube.com/user/AHRQHealthTV"><FontAwesomeIcon size="3x" icon={faYoutube} /></a></div>
                            <div><a href="http://www.linkedin.com/company/agency-for-healthcare-research-and-quality"><FontAwesomeIcon size="3x" icon={faLinkedin} /></a></div>
                        </div>

                    </Col>
                    <Col className="footer-column" xs={12} md={4}>
                    <h3 className="mb-3 bolder">Sign up for Email Updates</h3>
                        <h5>To sign up for updates or to access your subscriber preferences, please enter your email address below.</h5>
                        <Form className='email-signup'>
                            <div className={'signup-form'}>
                                <Form.Group className="flex" controlId="formBasicEmail">
                                    <Form.Control type="email" placeholder="Email Address" />
                                </Form.Group>
                            </div>
                            <div className={'signup-btn'}>
                                <Button type="submit">
                                    Sign Up
                                </Button>
                            </div>
                        </Form>
                    </Col>
                    <Col className="footer-column" xs={12} md={4}>
                    <h3 className="mb-3 bolder">Agency for Healthcare Research and Quality</h3>
                        <h5>5600 Fishers Lane</h5>
                        <h5>Rockville, MD 20857</h5>
                        <h5>Telephone: (301) 427-1364</h5>
                    </Col>
                </Row>
            </div>
        </Container>
        <Container fluid className="bottom-footer">
            <div className='footer-container'>

                <Row>
                    <Col xs={12} lg={8}>
                        <Row>
                            <Col className='footer-links' xs={6} md={3}>
                                <ul >
                                    <li><a href="https://www.ahrq.gov/cpi/about/careers/index.html">Careers</a></li>
                                    <li><a href="https://www.ahrq.gov/contact/index.html">Contact Us</a></li>
                                    <li><a href="https://www.ahrq.gov/topics/informacion-en-espanol/index.html">Español</a></li>
                                    <li><a href="https://info.ahrq.gov/">FAQs</a></li>
                                </ul>
                            </Col>
                            <Col className='footer-links' xs={6} md={3}>
                                <ul >
                                    <li><a href="https://www.ahrq.gov/policy/electronic/accessibility/index.html">Accessibility</a></li>
                                    <li><a href="https://www.ahrq.gov/policy/electronic/disclaimers/index.html">Disclaimers</a></li>
                                    <li><a href="https://www.ahrq.gov/policy/eeo/index.html">EEO</a></li>
                                    <li><a href="https://www.ahrq.gov/policy/electronic/about/policyix.html">Electronic Policies</a></li>
                                </ul>
                            </Col>
                            <Col className='footer-links' xs={6} md={3}>
                                <ul >
                                    <li><a href="https://www.ahrq.gov/policy/foia/index.html">FOIA</a></li>
                                    <li><a href="https://www.hhs.gov/web/governance/strategy.html">HHS Digital Strategy</a></li>
                                    <li><a href="https://www.hhs.gov/civil-rights/for-individuals/nondiscrimination/index.html">HHS Nondiscrimination Notice</a></li>
                                    <li><a href="https://oig.hhs.gov/">Inspector General</a></li>
                                </ul>
                            </Col>
                            <Col className='footer-links' xs={6} md={3}>
                                <ul >
                                    <li><a href="https://www.ahrq.gov/policy/electronic/plain-writing/index.html">Plain Writing Act</a></li>
                                    <li><a href="https://www.ahrq.gov/policy/electronic/privacy/index.html">Privacy Policy</a></li>
                                    <li><a href="https://www.hhs.gov/plugins.html">Viewers and Players</a></li>

                                </ul>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} lg={4} className="footer-side">
                        <ul>
                            <li><a href="https://www.hhs.gov/">U.S. Department of Health and Human Services</a></li>
                            <li><a href="https://www.whitehouse.gov/">The White House</a></li>
                            <li><a href="https://www.usa.gov/">USA.gov</a></li>
                        </ul>
                    </Col>
                </Row>
            </div>
        </Container>
    </>


    )
}

export default footer;